import { TFunction } from 'i18next'

import { TestRunStates } from '../models/hardware-tests.model'

export const getHardwareTestFinalScreenStatus = (state: TestRunStates | undefined, t: TFunction): string => {
  if (!state) {
    return ''
  }

  switch (state) {
    case 'CANCELED':
      return t('system-details.hardware-test.final-screen.cancelled')
    case 'SUCCESS':
      return t('system-details.hardware-test.final-screen.success')
    case 'FAILURE':
      return t('system-details.hardware-test.final-screen.fail')
    case 'INCONCLUSIVE':
      return t(`system-details.hardware-test.final-screen.inconclusive`)
    case 'STALE':
      return t(`system-details.hardware-test.final-screen.stale`)
    default:
      return ''
  }
}
